import { render, staticRenderFns } from "./room-nav-bar.vue?vue&type=template&id=f22e3ba8"
import script from "./room-nav-bar.vue?vue&type=script&lang=js"
export * from "./room-nav-bar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports